import {combineEpics} from 'redux-observable';
import * as epics from './index';

export const rootEpic = combineEpics(...Object.values(epics));
